export default __webpack_public_path__ + "static/media/close.56b21dd9.svg";